var EHDI = EHDI || Object.create(null);
var CKM = CKM || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

CKM.YummyMeter  = function() 
{
    EHDI.aka.Container.call(this);
    var DECAY_TIME = 10000;
    var BLIP_OFFSET = 65+12.75;
    var BLIP_SPACING = 20;
    var BLIP_COUNT = 15;
    var BLINK_DELAY = 75;


    var _me = this;
    var _visualContainer, _blips, _blipCase, _label, _blipBGCase;
    var _levelCounter;
    var _isYummyTime, _yummyTimer;
    var _blipTime, _blipTimer;
    var _topBlip;


    var _blinkTimer;

    var  _init = function()
    {
        _initProps();
        _initGraphics();
    }
    this.init = _init.bind(this);

    var _dispose = function()
    {
        _killGraphics();
        _killProps();
    }
    this.dispose = _dispose.bind(this);

    //Initialization
    var _initProps = function()
    {
        _levelCounter = 0;
        _isYummyTime = false;
        _yummyTimer = 0;
        _blipTimer = 0;
        _blipTime = DECAY_TIME / BLIP_COUNT;
        _blinkTimer = 0;
    }

    var _initGraphics = function()
    {      
        _visual = new EHDI.aka.Sprite(EHDI.Assets.images["cm_ui_yummyctn"]);
        _visual.anchor.set(0.5, 1);  
        _me.addChild(_visual);

        _blipCase = new EHDI.aka.Sprite();
        _blipCase.x = (_visual.width * -0.5) + 13;
        _blipCase.y = (BLIP_OFFSET * -1);

        _blipBGCase = new EHDI.aka.Sprite();
        _blipBGCase.x = _blipCase.x;
        _blipBGCase.y = _blipCase.y;

        _me.addChild(_blipBGCase);
        _me.addChild(_blipCase);


        var casePath = "";
        var blipPath = "";

        _blips= [];
        for(var i =0; i < BLIP_COUNT; i++)
        {
            var iterFactor = (i / 3);

            casePath = "cm_ui_meter_mid_ctn";
            if(iterFactor < 1)
            {
                blipPath ="cm_ui_meter_green";
            }
            else if(iterFactor < 2)
            {
                blipPath ="cm_ui_meter_yellowgreen";
            }
            else if(iterFactor < 3)
            {
                blipPath ="cm_ui_meter_yellow";
            }
            else if(iterFactor < 4)
            {
                blipPath ="cm_ui_meter_orange";
            }
            else
            {
                blipPath ="cm_ui_meter_red_mid";                
                if(i >= (BLIP_COUNT -1))
                {
                    casePath = "cm_ui_meter_top_ctn";
                    blipPath ="cm_ui_meter_red_top";
                }
            }

            var blip = new EHDI.aka.Sprite(EHDI.Assets.images[blipPath]);
            blip.y =  BLIP_SPACING * i * -1;
            blip.visible = false;

            _blips.push(blip);
            _blipCase.addChild(blip);

            var blipBG = new EHDI.aka.Sprite(EHDI.Assets.images[casePath]);
            blipBG.y = blip.y;

            _blipBGCase.addChild(blipBG);
        }

        _label = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("LBL_YUMMY"));
        _label.anchor.set(0.5, 1);  
        _label.y = -22.5;
        _label.tint = 0x8a92a0;
        _me.addChild(_label);
        

    }

    //Disposal
    var _killGraphics = function()
    {
        _me.removeChildren();        
        _visual.removeChildren();
        _visual = null;
    }
    var _killProps = function()
    {
    }

    var _update =  function(delta)
    {
        if(!_isYummyTime)
            return;

        _yummyTimer -= delta;
        if(_yummyTimer <= 0)
        {
            _deactivateYummyTime();
            return;
        }

        _blipTimer -= delta;

        if(_blipTimer <= 0)
            _levelDown();


        _blinkTimer -= delta;
        if(_blinkTimer <= 0)
        {
            // _blipCase.visible = !_blipCase.visible;

            if(_topBlip)
                _topBlip.visible = !_topBlip.visible;



            _blinkTimer = BLINK_DELAY;
        }
    }
    this.update = _update.bind(this);

    var _activateBlips = function(amt)
    {
        if(amt < 0)
            amt = 0;
        else if (amt > BLIP_COUNT)
            amt = BLIP_COUNT;

        if(amt == _levelCounter)
            return;

        for(var i=0; i<BLIP_COUNT; i++)
        {
            _blips[i].visible = (i < amt);

            if(i == (amt -1))
                _topBlip = _blips[i];
        }
        _levelCounter = amt;
    }

    var _levelUp = function()
    {
        if(_isYummyTime)
            return;

        _activateBlips(_levelCounter+1);

        if( _levelCounter >= BLIP_COUNT)
            _activateYummyTime();
    }
    this.levelUp = _levelUp.bind(this);

    var _levelDown = function()
    {
        if(!_isYummyTime)
            return;

        _blipTimer = _blipTime;
        _activateBlips(_levelCounter -1);
    }

    var _activateYummyTime = function()
    {
        _isYummyTime = true;
        _yummyTimer = DECAY_TIME;
        _blipTimer = _blipTime;
        _blinkTimer = BLINK_DELAY;
        
        _label.tint = 0xffffff;
        
                
        EHDI.GAME.bgm = EHDI.GAME.soundManager.playBGM("yummy");
    }

    var _deactivateYummyTime = function()
    {
        if(!_isYummyTime)
            return;

        _blinkTimer = 0;
        _activateBlips(0);

        _isYummyTime = false;
        
        _label.tint = 0x8a92a0;

                
        EHDI.GAME.bgm = EHDI.GAME.soundManager.playBGM("cakematch");
    }
    this.deactivateYummy = _deactivateYummyTime.bind(this);

    Object.defineProperties( _me, {
        "yummyTime":{
            get: function() {return _isYummyTime;},
            enumerable: true
        }
        
    });

    return _me;


}
CKM.YummyMeter.prototype = Object.create(EHDI.aka.Container.prototype);
